import { ReactElement } from 'react'
import Card from 'react-bootstrap/Card'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { UpComingSessionCard } from './subcomponents'
import { CardHeader, CardWrapper, Loader } from '../../../../components'
import strings from '../../../../locale/en'
import formatDate from '../../../../helpers/formatDate'

const UpComingSessions = (): ReactElement => {
  const { isLoading, sessions } = useSelector(
    (state: RootState) => ({
      isLoading: state.live?.isLoading,
      sessions: state.live?.upComingSessions
    }),
    shallowEqual
  )
  const {
    live: { upComingSession }
  } = strings

  return (
    <CardWrapper>
      <CardHeader>{upComingSession}</CardHeader>
      <Card.Body>
        {isLoading ? (
          <Loader />
        ) : (
          sessions?.map((session, index) => (
            <UpComingSessionCard
              subject={session?.subjectName}
              session={session?.sessionName}
              key={`upcomingsession-${index}`}
              index={index}
              date={formatDate(session?.sessionDate)}
              time={session?.startTime}
            />
          ))
        )}
      </Card.Body>
    </CardWrapper>
  )
}

export default UpComingSessions
